// import React, { useState, useEffect } from 'react';

// import { toast } from 'react-toastify';
// import { MdClose } from 'react-icons/md';
// import moment from 'moment';
// import { summaryApi } from 'common';

// const AdminRepairDashboard = () => {
//     const [requests, setRequests] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [selectedRequest, setSelectedRequest] = useState(null);
//     const [showReplyModal, setShowReplyModal] = useState(false);
//     const [replyMessage, setReplyMessage] = useState('');
//     const [replyStatus, setReplyStatus] = useState('');
//     const [sending, setSending] = useState(false);
//     const [filterStatus, setFilterStatus] = useState('all');

//     // Fetch all repair requests
//     const fetchRepairRequests = async () => {
//         try {
//             setLoading(true);
//             const response = await fetch(summaryApi.getAllRepairRequests.url, {
//                 method: summaryApi.getAllRepairRequests.method,
//                 credentials: 'include',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             const data = await response.json();

//             if (data.success) {
//                 setRequests(data.data);
//             } else {
//                 toast.error(data.message || 'Failed to fetch requests');
//             }
//         } catch (error) {
//             console.error('Error fetching requests:', error);
//             toast.error('Failed to fetch repair requests');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchRepairRequests();
//     }, []);

//     // Open reply modal
//     const handleReply = (request) => {
//         setSelectedRequest(request);
//         setReplyMessage(request.adminReply?.message || '');
//         setReplyStatus(request.status || 'pending');
//         setShowReplyModal(true);
//     };

//     // Send reply
//     const handleSendReply = async () => {
//         if (!replyMessage.trim()) {
//             toast.error('Please enter a reply message');
//             return;
//         }

//         setSending(true);

//         try {
//             const response = await fetch(
//                 summaryApi.replyToRepairRequest.url.replace(':id', selectedRequest._id),
//                 {
//                     method: summaryApi.replyToRepairRequest.method,
//                     credentials: 'include',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         message: replyMessage,
//                         status: replyStatus
//                     })
//                 }
//             );

//             const data = await response.json();

//             if (data.success) {
//                 toast.success('Reply sent successfully!');
//                 setShowReplyModal(false);
//                 setReplyMessage('');
//                 fetchRepairRequests(); // Refresh list
//             } else {
//                 toast.error(data.message || 'Failed to send reply');
//             }
//         } catch (error) {
//             console.error('Error sending reply:', error);
//             toast.error('Failed to send reply');
//         } finally {
//             setSending(false);
//         }
//     };

//     // Update status
//     const handleUpdateStatus = async (requestId, newStatus) => {
//         try {
//             const response = await fetch(
//                 summaryApi.updateRepairStatus.url.replace(':id', requestId),
//                 {
//                     method: summaryApi.updateRepairStatus.method,
//                     credentials: 'include',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({ status: newStatus })
//                 }
//             );

//             const data = await response.json();

//             if (data.success) {
//                 toast.success('Status updated successfully!');
//                 fetchRepairRequests(); // Refresh list
//             } else {
//                 toast.error(data.message || 'Failed to update status');
//             }
//         } catch (error) {
//             console.error('Error updating status:', error);
//             toast.error('Failed to update status');
//         }
//     };

//     // Get status badge color
//     const getStatusColor = (status) => {
//         switch (status) {
//             case 'pending':
//                 return 'bg-yellow-100 text-yellow-800';
//             case 'in-progress':
//                 return 'bg-blue-100 text-blue-800';
//             case 'completed':
//                 return 'bg-green-100 text-green-800';
//             case 'rejected':
//                 return 'bg-red-100 text-red-800';
//             default:
//                 return 'bg-gray-100 text-gray-800';
//         }
//     };

//     // Filter requests
//     const filteredRequests = filterStatus === 'all' 
//         ? requests 
//         : requests.filter(req => req.status === filterStatus);

//     if (loading) {
//         return (
//             <div className="flex justify-center items-center h-64">
//                 <div className="text-xl text-gray-600">Loading...</div>
//             </div>
//         );
//     }

//     return (
//         <div className="p-6">
//             <div className="mb-6">
//                 <h1 className="text-3xl font-bold text-gray-800 mb-4">Repair Requests Dashboard</h1>
                
//                 {/* Filter Tabs */}
//                 <div className="flex gap-2 mb-4">
//                     {['all', 'pending', 'in-progress', 'completed', 'rejected'].map(status => (
//                         <button
//                             key={status}
//                             onClick={() => setFilterStatus(status)}
//                             className={`px-4 py-2 rounded-md font-medium capitalize ${
//                                 filterStatus === status
//                                     ? 'bg-blue-600 text-white'
//                                     : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                             }`}
//                         >
//                             {status} ({status === 'all' ? requests.length : requests.filter(r => r.status === status).length})
//                         </button>
//                     ))}
//                 </div>
//             </div>

//             {filteredRequests.length === 0 ? (
//                 <div className="text-center py-12 bg-gray-50 rounded-lg">
//                     <p className="text-gray-600 text-lg">No repair requests found</p>
//                 </div>
//             ) : (
//                 <div className="grid gap-6">
//                     {filteredRequests.map((request) => (
//                         <div key={request._id} className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
//                             <div className="flex justify-between items-start mb-4">
//                                 <div>
//                                     <h3 className="text-xl font-semibold text-gray-800">
//                                         {request.deviceBrand} {request.deviceModel}
//                                     </h3>
//                                     <p className="text-sm text-gray-500">
//                                         {request.deviceType} • Submitted {moment(request.createdAt).fromNow()}
//                                     </p>
//                                 </div>
//                                 <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(request.status)}`}>
//                                     {request.status}
//                                 </span>
//                             </div>

//                             {/* Customer Info */}
//                             <div className="mb-4 p-4 bg-gray-50 rounded-md">
//                                 <h4 className="font-semibold text-gray-700 mb-2">Customer Information</h4>
//                                 <p className="text-sm text-gray-600">
//                                     <span className="font-medium">Name:</span> {request.userId?.firstName} {request.userId?.lastName}
//                                 </p>
//                                 <p className="text-sm text-gray-600">
//                                     <span className="font-medium">Email:</span> {request.contactEmail}
//                                 </p>
//                                 <p className="text-sm text-gray-600">
//                                     <span className="font-medium">Phone:</span> {request.contactPhone}
//                                 </p>
//                             </div>

//                             {/* Issue Description */}
//                             <div className="mb-4">
//                                 <h4 className="font-semibold text-gray-700 mb-2">Issue Description</h4>
//                                 <p className="text-gray-600">{request.issueDescription}</p>
//                             </div>

//                             {/* Images */}
//                             {request.images && request.images.length > 0 && (
//                                 <div className="mb-4">
//                                     <h4 className="font-semibold text-gray-700 mb-2">Device Images</h4>
//                                     <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//                                         {request.images.map((image, index) => (
//                                             <img
//                                                 key={index}
//                                                 src={image}
//                                                 alt={`Device ${index + 1}`}
//                                                 className="w-full h-32 object-cover rounded-md border border-gray-300 cursor-pointer hover:opacity-80"
//                                                 onClick={() => window.open(image, '_blank')}
//                                             />
//                                         ))}
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Admin Reply */}
//                             {request.adminReply?.message && (
//                                 <div className="mb-4 p-4 bg-blue-50 rounded-md border border-blue-200">
//                                     <h4 className="font-semibold text-blue-800 mb-2">Admin Reply</h4>
//                                     <p className="text-gray-700 mb-2">{request.adminReply.message}</p>
//                                     <p className="text-sm text-gray-500">
//                                         Replied by {request.adminReply.repliedBy?.firstName} {request.adminReply.repliedBy?.lastName} • 
//                                         {moment(request.adminReply.repliedAt).format('MMM DD, YYYY [at] h:mm A')}
//                                     </p>
//                                 </div>
//                             )}

//                             {/* Action Buttons */}
//                             <div className="flex gap-3">
//                                 <button
//                                     onClick={() => handleReply(request)}
//                                     className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium"
//                                 >
//                                     {request.adminReply?.message ? 'Update Reply' : 'Send Reply'}
//                                 </button>

//                                 <select
//                                     value={request.status}
//                                     onChange={(e) => handleUpdateStatus(request._id, e.target.value)}
//                                     className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 >
//                                     <option value="pending">Pending</option>
//                                     <option value="in-progress">In Progress</option>
//                                     <option value="completed">Completed</option>
//                                     <option value="rejected">Rejected</option>
//                                 </select>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}

//             {/* Reply Modal */}
//             {showReplyModal && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//                         <div className="p-6">
//                             <div className="flex justify-between items-center mb-4">
//                                 <h3 className="text-2xl font-bold text-gray-800">Reply to Customer</h3>
//                                 <button
//                                     onClick={() => setShowReplyModal(false)}
//                                     className="text-gray-500 hover:text-gray-700"
//                                 >
//                                     <MdClose size={24} />
//                                 </button>
//                             </div>

//                             <div className="mb-4">
//                                 <p className="text-gray-600 mb-2">
//                                     <span className="font-semibold">Customer:</span> {selectedRequest?.userId?.firstName} {selectedRequest?.userId?.lastName}
//                                 </p>
//                                 <p className="text-gray-600">
//                                     <span className="font-semibold">Device:</span> {selectedRequest?.deviceBrand} {selectedRequest?.deviceModel}
//                                 </p>
//                             </div>

//                             <div className="mb-4">
//                                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                                     Status
//                                 </label>
//                                 <select
//                                     value={replyStatus}
//                                     onChange={(e) => setReplyStatus(e.target.value)}
//                                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 >
//                                     <option value="pending">Pending</option>
//                                     <option value="in-progress">In Progress</option>
//                                     <option value="completed">Completed</option>
//                                     <option value="rejected">Rejected</option>
//                                 </select>
//                             </div>

//                             <div className="mb-6">
//                                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                                     Reply Message *
//                                 </label>
//                                 <textarea
//                                     value={replyMessage}
//                                     onChange={(e) => setReplyMessage(e.target.value)}
//                                     placeholder="Enter your reply to the customer..."
//                                     rows="6"
//                                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 />
//                             </div>

//                             <div className="flex gap-3 justify-end">
//                                 <button
//                                     onClick={() => setShowReplyModal(false)}
//                                     className="px-6 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
//                                     disabled={sending}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={handleSendReply}
//                                     disabled={sending || !replyMessage.trim()}
//                                     className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
//                                 >
//                                     {sending ? 'Sending...' : 'Send Reply'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AdminRepairDashboard;




import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { MdClose } from 'react-icons/md';
import moment from 'moment';
import { useTheme } from "../../components/Theme/ThemeProvider";
import { summaryApi } from 'common';
import { authFetch } from '../../helpers/authFetch';

const AdminRepairDashboard = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [showReplyModal, setShowReplyModal] = useState(false);
    const [replyMessage, setReplyMessage] = useState('');
    const [replyStatus, setReplyStatus] = useState('');
    const [sending, setSending] = useState(false);
    const [filterStatus, setFilterStatus] = useState('all');
    const { colors } = useTheme();

    // Fetch all repair requests
    const fetchRepairRequests = async () => {
        try {
            setLoading(true);
            const response = await authFetch(summaryApi.getAllRepairRequests.url, {
                method: summaryApi.getAllRepairRequests.method,
                
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (data.success) {
                setRequests(data.data);
            } else {
                toast.error(data.message || 'Failed to fetch requests');
            }
        } catch (error) {
            console.error('Error fetching requests:', error);
            toast.error('Failed to fetch repair requests');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRepairRequests();
    }, []);

    // Open reply modal
    const handleReply = (request) => {
        setSelectedRequest(request);
        setReplyMessage(request.adminReply?.message || '');
        setReplyStatus(request.status || 'pending');
        setShowReplyModal(true);
    };

    // Send reply
    const handleSendReply = async () => {
        if (!replyMessage.trim()) {
            toast.error('Please enter a reply message');
            return;
        }

        setSending(true);

        try {
            const response = await authFetch(
                summaryApi.replyToRepairRequest.url.replace(':id', selectedRequest._id),
                {
                    method: summaryApi.replyToRepairRequest.method,
                    
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        message: replyMessage,
                        status: replyStatus
                    })
                }
            );

            const data = await response.json();

            if (data.success) {
                toast.success('Reply sent successfully!');
                setShowReplyModal(false);
                setReplyMessage('');
                fetchRepairRequests();
            } else {
                toast.error(data.message || 'Failed to send reply');
            }
        } catch (error) {
            console.error('Error sending reply:', error);
            toast.error('Failed to send reply');
        } finally {
            setSending(false);
        }
    };

    // Update status
    const handleUpdateStatus = async (requestId, newStatus) => {
        try {
            const response = await authFetch(
                summaryApi.updateRepairStatus.url.replace(':id', requestId),
                {
                    method: summaryApi.updateRepairStatus.method,
                    
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ status: newStatus })
                }
            );

            const data = await response.json();

            if (data.success) {
                toast.success('Status updated successfully!');
                fetchRepairRequests();
            } else {
                toast.error(data.message || 'Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
            toast.error('Failed to update status');
        }
    };

    // Get status badge color
    const getStatusColor = (status) => {
        switch (status) {
            case 'pending':
                return { bg: `${colors.warning}20`, text: colors.warning };
            case 'in-progress':
                return { bg: `${colors.primary}20`, text: colors.primary };
            case 'completed':
                return { bg: `${colors.success}20`, text: colors.success };
            case 'rejected':
                return { bg: `${colors.error}20`, text: colors.error };
            default:
                return { bg: `${colors.textSecondary}20`, text: colors.textSecondary };
        }
    };

    // Filter requests
    const filteredRequests = filterStatus === 'all' 
        ? requests 
        : requests.filter(req => req.status === filterStatus);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl" style={{ color: colors.textSecondary }}>Loading...</div>
            </div>
        );
    }

    return (
        <div className="p-6" style={{ backgroundColor: colors.bgPrimary, minHeight: '100vh' }}>
            <div className="mb-6">
                <h1 className="text-3xl font-bold mb-4" style={{ color: colors.text }}>
                    Repair Requests Dashboard
                </h1>
                
                {/* Filter Tabs */}
                <div className="flex gap-2 mb-4 flex-wrap">
                    {['all', 'pending', 'in-progress', 'completed', 'rejected'].map(status => (
                        <button
                            key={status}
                            onClick={() => setFilterStatus(status)}
                            className="px-4 py-2 rounded-md font-medium capitalize transition"
                            style={{
                                backgroundColor: filterStatus === status ? colors.primary : colors.bgSecondary,
                                color: filterStatus === status ? '#ffffff' : colors.text,
                                border: `1px solid ${colors.border}`
                            }}
                        >
                            {status} ({status === 'all' ? requests.length : requests.filter(r => r.status === status).length})
                        </button>
                    ))}
                </div>
            </div>

            {filteredRequests.length === 0 ? (
                <div className="text-center py-12 rounded-lg" style={{ backgroundColor: colors.bgSecondary }}>
                    <p className="text-lg" style={{ color: colors.textSecondary }}>No repair requests found</p>
                </div>
            ) : (
                <div className="grid gap-6">
                    {filteredRequests.map((request) => (
                        <div 
                            key={request._id} 
                            className="rounded-lg shadow-md p-6"
                            style={{ 
                                backgroundColor: colors.bgSecondary,
                                border: `1px solid ${colors.border}`
                            }}
                        >
                            <div className="flex justify-between items-start mb-4">
                                <div>
                                    <h3 className="text-xl font-semibold" style={{ color: colors.text }}>
                                        {request.deviceBrand} {request.deviceModel}
                                    </h3>
                                    <p className="text-sm" style={{ color: colors.textSecondary }}>
                                        {request.deviceType} • Submitted {moment(request.createdAt).fromNow()}
                                    </p>
                                </div>
                                <span 
                                    className="px-3 py-1 rounded-full text-sm font-medium"
                                    style={{
                                        backgroundColor: getStatusColor(request.status).bg,
                                        color: getStatusColor(request.status).text
                                    }}
                                >
                                    {request.status}
                                </span>
                            </div>

                            {/* Customer Info */}
                            <div className="mb-4 p-4 rounded-md" style={{ backgroundColor: colors.bgTertiary }}>
                                <h4 className="font-semibold mb-2" style={{ color: colors.text }}>Customer Information</h4>
                                <p className="text-sm" style={{ color: colors.textSecondary }}>
                                    <span className="font-medium">Name:</span> {request.userId?.firstName} {request.userId?.lastName}
                                </p>
                                <p className="text-sm" style={{ color: colors.textSecondary }}>
                                    <span className="font-medium">Email:</span> {request.contactEmail}
                                </p>
                                <p className="text-sm" style={{ color: colors.textSecondary }}>
                                    <span className="font-medium">Phone:</span> {request.contactPhone}
                                </p>
                            </div>

                            {/* Issue Description */}
                            <div className="mb-4">
                                <h4 className="font-semibold mb-2" style={{ color: colors.text }}>Issue Description</h4>
                                <p style={{ color: colors.textSecondary }}>{request.issueDescription}</p>
                            </div>

                            {/* Images */}
                            {request.images && request.images.length > 0 && (
                                <div className="mb-4">
                                    <h4 className="font-semibold mb-2" style={{ color: colors.text }}>Device Images</h4>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                        {request.images.map((image, index) => (
                                            <img
                                                key={index}
                                                src={image}
                                                alt={`Device ${index + 1}`}
                                                className="w-full h-32 object-cover rounded-md cursor-pointer hover:opacity-80 transition"
                                                style={{ border: `1px solid ${colors.border}` }}
                                                onClick={() => window.open(image, '_blank')}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Admin Reply */}
                            {request.adminReply?.message && (
                                <div 
                                    className="mb-4 p-4 rounded-md"
                                    style={{ 
                                        backgroundColor: `${colors.success}15`,
                                        border: `1px solid ${colors.success}40`
                                    }}
                                >
                                    <h4 className="font-semibold mb-2" style={{ color: colors.success }}>Admin Reply</h4>
                                    <p className="mb-2" style={{ color: colors.text }}>{request.adminReply.message}</p>
                                    <p className="text-sm" style={{ color: colors.textSecondary }}>
                                        Replied by {request.adminReply.repliedBy?.firstName} {request.adminReply.repliedBy?.lastName} • 
                                        {moment(request.adminReply.repliedAt).format('MMM DD, YYYY [at] h:mm A')}
                                    </p>
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div className="flex gap-3 flex-wrap">
                                <button
                                    onClick={() => handleReply(request)}
                                    className="px-4 py-2 rounded-md font-medium transition"
                                    style={{ 
                                        backgroundColor: colors.primary,
                                        color: '#ffffff'
                                    }}
                                >
                                    {request.adminReply?.message ? 'Update Reply' : 'Send Reply'}
                                </button>

                                <select
                                    value={request.status}
                                    onChange={(e) => handleUpdateStatus(request._id, e.target.value)}
                                    className="px-4 py-2 rounded-md focus:outline-none focus:ring-2"
                                    style={{
                                        backgroundColor: colors.bgTertiary,
                                        color: colors.text,
                                        border: `1px solid ${colors.border}`,
                                        '--tw-ring-color': colors.primary
                                    }}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="in-progress">In Progress</option>
                                    <option value="completed">Completed</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Reply Modal */}
            {showReplyModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div 
                        className="rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto"
                        style={{ backgroundColor: colors.bgSecondary }}
                    >
                        <div className="p-6">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-2xl font-bold" style={{ color: colors.text }}>
                                    Reply to Customer
                                </h3>
                                <button
                                    onClick={() => setShowReplyModal(false)}
                                    style={{ color: colors.textSecondary }}
                                    className="hover:opacity-70 transition"
                                >
                                    <MdClose size={24} />
                                </button>
                            </div>

                            <div className="mb-4">
                                <p className="mb-2" style={{ color: colors.textSecondary }}>
                                    <span className="font-semibold">Customer:</span> {selectedRequest?.userId?.firstName} {selectedRequest?.userId?.lastName}
                                </p>
                                <p style={{ color: colors.textSecondary }}>
                                    <span className="font-semibold">Device:</span> {selectedRequest?.deviceBrand} {selectedRequest?.deviceModel}
                                </p>
                            </div>

                            <div className="mb-4">
                                <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                                    Status
                                </label>
                                <select
                                    value={replyStatus}
                                    onChange={(e) => setReplyStatus(e.target.value)}
                                    className="w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2"
                                    style={{
                                        backgroundColor: colors.bgTertiary,
                                        color: colors.text,
                                        border: `1px solid ${colors.border}`,
                                        '--tw-ring-color': colors.primary
                                    }}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="in-progress">In Progress</option>
                                    <option value="completed">Completed</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            <div className="mb-6">
                                <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                                    Reply Message *
                                </label>
                                <textarea
                                    value={replyMessage}
                                    onChange={(e) => setReplyMessage(e.target.value)}
                                    placeholder="Enter your reply to the customer..."
                                    rows="6"
                                    className="w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2"
                                    style={{
                                        backgroundColor: colors.bgTertiary,
                                        color: colors.text,
                                        border: `1px solid ${colors.border}`,
                                        '--tw-ring-color': colors.primary
                                    }}
                                />
                            </div>

                            <div className="flex gap-3 justify-end">
                                <button
                                    onClick={() => setShowReplyModal(false)}
                                    className="px-6 py-2 rounded-md transition"
                                    disabled={sending}
                                    style={{
                                        backgroundColor: colors.bgTertiary,
                                        color: colors.text,
                                        border: `1px solid ${colors.border}`
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSendReply}
                                    disabled={sending || !replyMessage.trim()}
                                    className="px-6 py-2 rounded-md transition disabled:opacity-50 disabled:cursor-not-allowed"
                                    style={{
                                        backgroundColor: colors.primary,
                                        color: '#ffffff'
                                    }}
                                >
                                    {sending ? 'Sending...' : 'Send Reply'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminRepairDashboard;